/** 七类原生接收运价的来源标识；维护和分享沿用普通运价的状态与权限规则。 */

/** 后端只暴露是否收到，来源关系身份保持内部字段。 */
export interface ReceivedRate {
  /** true表示收到的运价，可编辑和再次分享；上游更新覆盖映射的本地运价。 */
  received?: boolean
  /** 沃行之家订阅导入；取消后保留，不限制本地操作。 */
  familySubscribed?: boolean
}

/** @param record 维护列表或详情响应 @returns 当前记录是否属于接收运价，不作为只读或权限判断 */
export function isReceivedRate(record: unknown): boolean {
  return (
    typeof record === 'object' &&
    record !== null &&
    'received' in record &&
    record.received === true
  )
}
